import React, { useMemo } from "react";
import FlexBox from "./basic/Box/FlexBox";
import { Colors } from "baseStyles/enums/colors";
import Text from "./basic/Text";

export enum BannerTypes {
    info,
    warning,
    error,
    success,
    neutral
}

export const Banner: React.FC<{type?: BannerTypes, emphasis?: boolean, fullWidth?: boolean}> = ({children, type = BannerTypes.info, emphasis = false, fullWidth=false}: any) => {

    const style = useMemo(() => {
        switch (type) {
            case BannerTypes.info:
                return { backgroundColor: Colors.LIGHT_BLUE_2, color: Colors.CONTENT_NOTICE_INFO };
            case BannerTypes.warning:
                return { backgroundColor: Colors.LIGHT_YELLOW_2, color: Colors.DARK_YELLOW };
            case BannerTypes.error:
                return { backgroundColor: Colors.LIGHT_RED_2, color: Colors.CONTENT_NOTICE_ERROR };
            case BannerTypes.success:
                return { backgroundColor: Colors.LIGHT_GREEN_2, color: Colors.DARK_GREEN };
            case BannerTypes.neutral:
                return { backgroundColor: Colors.WHITE_2, color: Colors.CONTENT_TEXT_SECONDARY };
            default:
                return { backgroundColor: Colors.LIGHT_BLUE_2, color: Colors.CONTENT_NOTICE_INFO };
        }
    }, [type])

    return (
        <FlexBox fullWidth={fullWidth} borderRadius={8} backgroundColor={style.backgroundColor} gap={8} padding={"6px 12px"}>
            <i style={{color: style.color, fontSize: 16}} className="iconcust-iconinfo3" ></i>
            <FlexBox flex={1}><Text.SMALL fullWidth emphasis={emphasis} lines={3} color={style.color}>{children}</Text.SMALL></FlexBox>
        </FlexBox>
    )
}